import { QueryClient } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // выключаем автоматический рефетч на фокус окна, т.к. у нас есть нотифаер как будто нам это не нужно,
      // так же есть опасения, что это может вызвать немало запросов при смене фокуса окон
      refetchOnWindowFocus: false
    }
  }
});
